import React, { useMemo } from 'react';
import { Button, Form } from 'antd';
import styles from './index.module.scss';
import PasswordLogin from 'lib/publicUsecase/PasswordLogin';
import { noop } from 'lodash';
import { useHistory } from 'react-router';
import APP_ROUTE from 'constant/route';
import LoginAgreementItem from 'component/AuthForm/LoginAgreementItem';
import LoginGraphicCapatchaItem from 'component/AuthForm/LoginGraphicCapatchaItem';
import LoginMobileItem from 'component/AuthForm/LoginMobileItem';
import LoginPasswordItem from 'component/AuthForm/LoginPasswordItem';
import { Pivot } from 'api';
import { getSessionId } from 'util/session';
import { getGraphicCaptchaUrl } from 'util/graphicCaptcha';
import { afterLogin } from 'model/login';
import { useDispatch } from 'react-redux';
import { getMobile } from 'data/storage';
import { useStore } from '../useStore';

interface IProps {}

interface FormData {
  mobile: string;
  password: string;
  agreement: boolean;
  graphicCaptcha: string;
}

const LoginWithPassword: React.FunctionComponent<IProps> = () => {
  const history = useHistory();
  const [form] = Form.useForm<FormData>();
  const dispatch = useDispatch();

  const { formStore, stateStore, stateData, handleFromDataChange } = useStore<FormData>(
    { mobile: getMobile(), password: '', agreement: false, graphicCaptcha: '' },
    {
      loginLoading: false,
      graphicCaptchaUrl: '',
      graphicCaptchaError: '',
      passwordError: ''
    }
  );

  function onFieldsChange() {
    const newData = form.getFieldsValue();
    handleFromDataChange(newData);
  }

  const passowrdLoagin = new PasswordLogin({
    API: {
      getSessionId,
      getGraphicCaptchaUrl,
      loginByPassword: (data) => Pivot.loginByPassword(data).toPromise()
    },
    formStore: formStore as any,
    stateStore
  });

  async function handlePasswordLogin() {
    const res = await form.validateFields().catch(noop);
    if (!res) return;
    const { data } = await passowrdLoagin.fetchPasswordLogin();
    if (!data) return;
    dispatch(
      afterLogin({
        token: data.access_token,
        userId: data.userId,
        mobile: formStore.value.mobile
      })
    );
  }

  const { mobile, password, graphicCaptcha } = form.getFieldsValue();
  const btnEnable = useMemo(() => {
    return mobile && password && (!stateData.graphicCaptchaUrl || graphicCaptcha);
  }, [mobile, password, graphicCaptcha, stateData.graphicCaptchaUrl]);

  function toForgotPassword() {
    history.push(APP_ROUTE.FORGOT_PASSWORD);
  }

  function handlePasswordInuput() {
    if (stateStore.value.passwordError) {
      stateStore.set({ passwordError: '' });
    }
  }

  return (
    <div className={styles.main}>
      <div className={styles.mainTitleContainer}>
        <div className={styles.mainTitle}>账号登录</div>
      </div>
      <div className={styles.formWrapper}>
        <Form form={form} onFieldsChange={onFieldsChange} initialValues={formStore.value}>
          <LoginMobileItem name="mobile" />
          <LoginPasswordItem name="password" help={stateData.passwordError} onChange={handlePasswordInuput} type="login" />
          <div className={styles['forgot-password']}>
            <span onClick={toForgotPassword}>忘记密码</span>
          </div>
          <LoginGraphicCapatchaItem
            help={stateData.graphicCaptchaError}
            name="graphicCaptcha"
            src={stateData.graphicCaptchaUrl}
            onReset={passowrdLoagin.refrashGraphicCaptchaUrl}
          />
          <Button loading={stateData.loginLoading} disabled={!btnEnable} type="primary" block size="large" htmlType="submit" onClick={handlePasswordLogin}>
            登录
          </Button>
          <LoginAgreementItem name="agreement" />
        </Form>
      </div>
    </div>
  );
};

export default LoginWithPassword;
